export default __webpack_public_path__ + "static/media/IMG_20230718_170639 - Vivek Kumar.388afcd4.jpg";